export const supplies = {
	pageTitle: "Insumos",
	pageDescription:
		"Insumos são todos os materiais que são utilizados para a produção de determinado produto. ou na criação de um outro insumo. Nesta tela é possível cadastrar e visualizar todos os insumos cadastrados em um place.",
	searchPlaceholder: "Pesquisar insumos",
	formErrors: {
		supplyName: "Nome do insumo precisa ser preenchido",
		conversionRule: "Os valores da regra de conversão precisam ser preenchidos",
		productRulesNotValidCount: "O valor de perda não pode ser maior que a quantidade",
	},
	table: {
		name: "Nome",
		productionRule: "Receitas e produção",
		conversionRule: "Regra de conversão",
		hasProductionRule: "Tem ficha técnica?",
		actions: "Ações",
		clickToEdit: "Clique para editar",
		sku: "SKU",
		yieldPercentage: "Rendimento",
		links: "Produtos e insumos Vinc.",
		stocks: "Estoques",
	},
	supplyActionModal: {
		title: {
			supply: "Vínculos do insumo",
			stock: "Vínculos do estoque",
		},
		description: {
			supply: "Relação de cadastro com os quais esse item está vinculado",
			stock: "Relação de estoques onde o produto está presente",
		},
		seeProductButton: "Ver produto",
		seeStockButton: "Ver estoque",
	},
	deleteWarning: "Tem certeza que deseja apagar este item?",
	addSupplies: "Adicionar insumo",
	editSupplies: "Editar insumo",
	importSupplies: "Importar insumos",
	exportToExcel: "Exportar para excel",
	addSuppliesModal: {
		name: "Nome",
		unitMeasure: "Unidade de Medida",
		units: "Unidades",
		errorMessage: "Esse campo é obrigatório",
		yieldPercentage: "Rendimento",
	},
	suppliesErrorsTableColumns: {
		supply: "Insumo",
		error: "Erro",
	},
	importModal: {
		title: "Importar insumo",
		sheetFileName: "Insumos",
		conclude: "Concluir",
		buttonText: "Escolha uma planilha",
	},
	step: {
		supply: "Insumo",
		ingredients: "Ingredientes",
	},
	addInputModal: {
		title: "Adicionar insumo",
		supply: "Insumo ou produto",
		name: "Nome",
		placeholderName: "Insira o nome do insumo",
		sku: "SKU",
		placeholderSKU: "Insira o SKU",
		image: "Foto",
		descriptionImage: "Imagem quadrada  ou 500x500 pixels",
		yieldPercentage: "Rendimento",
		basicStorageUnit: "Estoque controlado por",
		placeholderBasicStorageUnit: "Insira a unidade de medida",
		aboutIngredients: "Sobre ingredientes",
		ingredientsInfo:
			"Preencha os campos de ingredientes apenas se o produto for uma receita que utiliza outros insumos. Por exemplo, molho de tomate precisa de ingredientes, mas tomate não.",
		selectInput: "Selecione um insumo ou produto",
		quantity: "Quantidade",
		loss: "Perda",
		addIngredient: "Adicionar ingrediente",
	},
	productRule: {
		title: "Ficha técnica - {{productName}}",
		generatedQuantity: "Quantidade gerada",
		tooltipMessage:
			"Para alterar a quantidade gerada é necessário remover a ficha técnica e cria-lá novamente.",
		form: {
			product: "Produto",
			quantity: "Quantidade",
			loss: "Perda",
		},
		addAnotherSupply: "Adicionar outro insumo",
		hasProductionRuleError:
			"Atenção, esta ficha técnica está com erro. Remova a ficha técnica e adicione novamente.",
		warnings: {
			emptySupplies: "Selecione um insumo",
			emptyQuantity: "Adicione a quantidade do insumo",
			repeatEntry: "Você adicionou insumos repetidos",
		},
		erros: { countLossInvalid: "O valor de perda não pode ser maior que a quantidade" },
	},
	cancel: "Cancelar",
	conclude: "Concluir",
	erase: "Apagar",
	remove: "Remover",
	yes: "Sim",
	no: "Não",
	yesCaps: "SIM",
	noCaps: "NÃO",
	edit: "Editar",
	delete: "Deletar",
	link: "Vínculo",
	links: "Vínculos",
	deleteSelectedSupplies: "Excluir insumos selecionados",
	deleteSelectedItens: "Excluir itens selecionados",
	deleteSupply: "Excluir insumo",
	deleteItems: "Excluir itens",
	importSupply: "Importar insumo",
	import: "Importar",
	confirmDeleteMessage: {
		multiple:
			"Ao confirmar a ação você exclui permanentemente {{quantity}} insumos. Deseja continuar?",
		single:
			"Ao confirmar a ação você exclui permanentemente o insumo {{supply}}. Deseja continuar?",
	},
	viewRules: "Ver receitas",
	viewConversionRule: "Ver regra",
	doesNotHave: "Não possui",
	copiedSuccessfully: "Copiado com sucesso",
	cannotDeleteSupply:
		"Não é possível deletar pois o insumo está vinculado a outros produtos",
};
